// This is taken from the WPS version of the pluralizer. While not ideal to have this duplicated given that the uses
// for this isn't likly to be around in the next version adding here for now. More info in sim.
// TODO: Remove / move to wps https://issues.amazon.com/issues/AVWebDetailPage-2914

export enum PluralizerSuffix {
  zero,
  one,
  few,
  many,
  other
}

interface LocaleRulesMap {
  [locale: string]: (num: number) => PluralizerSuffix
}

const nonPlural = () => PluralizerSuffix.other

const singularOrPlural = (num: number) => num === 1 ? PluralizerSuffix.one : PluralizerSuffix.other

const zeroSingular = (num: number) => (num >= 0 && num < 2) ? PluralizerSuffix.one : PluralizerSuffix.other

const polishPlural = (num: number) => {
  if (num == 1)
    return PluralizerSuffix.one
  else if ((num % 10 >=2 && num % 10 <= 4) && !(num % 100 >= 12 && num % 100 <= 14))
    return PluralizerSuffix.few
  else
    return PluralizerSuffix.many
}

const localeRules: LocaleRulesMap = {
  "de_DE": singularOrPlural,
  "en_GB": singularOrPlural,
  "en_CA": singularOrPlural,
  "en_IN": singularOrPlural,
  "en_US": singularOrPlural,
  "es_ES": singularOrPlural,
  "fr_CA": zeroSingular,
  "fr_FR": zeroSingular,
  "it_IT": singularOrPlural,
  "ja_JP": nonPlural,
  "pt_BR": zeroSingular,
  "zh_CN": nonPlural,
  "zh_TW": nonPlural,
  "pl_PL": polishPlural
}

export const getStringIdSuffix = (num: number, locale: string) => {

  const fn = localeRules[locale]

  return fn ? fn(num) : undefined
}